import { toast } from 'react-toastify';

const getMobileNoInfoService = (actionCallback, mobileNo,history) => {
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    fetch(baseUrl + "/rest/card/detailsByMobileNumber/" + mobileNo, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
        })
    })
        .then(res => {

            if (res.status === 200) {
                if (localStorage.getItem('mobileNoToast') === 'first') {
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('mobileNoToast', 'second')
                }
                res.json().then(json => {
                    
                  if(Array.isArray(json)) {
                    actionCallback(json, "success")
                    if(history !== undefined){ history.push('/mobnodetails') }
                  }
                  else {
                    localStorage.setItem('cardRefNumber',json.cardReferenceId)
                    actionCallback(json, "success")
                    if(history !== undefined){ history.push('/carddetails') }
                  }
                })
            }
            else if(res.status === 401){
                actionCallback("401", "sessionout")
                this.props.history.push('/SessionOut')
            }
            else if(res.status === 500) {
                if (localStorage.getItem('mobileNoToast') === 'first') {
                    toast.error('Not a valid mobile number', {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                // localStorage.setItem('mobileNoToast', 'second')
            }
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getMobileNoInfoService;


// WEBPACK FOOTER //
// ./src/services/components/mobileno_info.jsx